/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit App/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Account from './Account/index'
import Auth from './Auth/index'
import CaseCloserNotFound from './CaseCloserNotFound/index'
import ChooseUser from './ChooseUser/index'
import No from './No/index'
import NotFound from './NotFound/index'
import Notifications from 'DesignSystem/Notifications/index'
import React from 'react'
import RuntimeError from './RuntimeError/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'
let AppointmentRequest = React.lazy(() => import('./AppointmentRequest/index'))
let ConfirmAppointment = React.lazy(() => import('./ConfirmAppointment/index'))
let GoogleTagManager = React.lazy(() => import('DesignSystem/GoogleTagManager/react'))
let Nps = React.lazy(() => import('./Nps/index'))
let Pay = React.lazy(() => import('./Pay/index'))
let SignatureRequest = React.lazy(() => import('./SignatureRequest/index'))
let TreatmentFlow = React.lazy(() => import('./TreatmentFlow/index'))
let VirtualRoom = React.lazy(() => import('./VirtualRoom/index'))



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function App({
  children,
  viewPath = "/App"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Auth'}>
<Auth
  viewPath={`${viewPath}/Auth`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ChooseUser'}>
<ChooseUser
  viewPath={`${viewPath}/ChooseUser`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Account'}>
<Account
  viewPath={`${viewPath}/Account`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'AppointmentRequest'}>
<AppointmentRequest
  viewPath={`${viewPath}/AppointmentRequest`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Nps'}>
<Nps
  viewPath={`${viewPath}/Nps`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'VirtualRoom'}>
<VirtualRoom
  viewPath={`${viewPath}/VirtualRoom`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SignatureRequest'}>
<SignatureRequest
  viewPath={`${viewPath}/SignatureRequest`}
/>
</fromFlow.When>
<GoogleTagManager
  viewPath={`${viewPath}/GoogleTagManager`}
/>
<fromFlow.When is={flowValue === 'TreatmentFlow'}>
<TreatmentFlow
  viewPath={`${viewPath}/TreatmentFlow`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Pay'}>
<Pay
  viewPath={`${viewPath}/Pay`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ConfirmAppointment'}>
<ConfirmAppointment
  viewPath={`${viewPath}/ConfirmAppointment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'RuntimeError'}>
<RuntimeError
  viewPath={`${viewPath}/RuntimeError`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CaseCloserNotFound'}>
<CaseCloserNotFound
  viewPath={`${viewPath}/CaseCloserNotFound`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NotFound'}>
<NotFound
  viewPath={`${viewPath}/NotFound`}
/>
</fromFlow.When>
<div
  data-testid="App.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Notifications
  viewPath={`${viewPath}/Notifications`}
/>
</div>
{children}
</React.Fragment>)
}